//import Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';

//import Components
import Button from '../../../components/Button/Button';
import Language from '../../../language/language.json';
import Fullpage from '../../../hoc/Fullpage/Fullpage';
import Icons from '../../../assets/icons/icons';
import ExplainCard from './ExplainCard/ExplainCard';

import * as homeActions from '../actions/homeActions';

//import Style classes
import './Introduction.css';

class Introduction extends Component {

    componentDidMount(){
        this.props.onLoadIntroductions();
    }

    render() {
        if(!this.props.introductions){
            return (
                <Fullpage className='Introduction' padding="30px 70px">
                    {sideBar}
                    <div className="Explanation"></div>
                </Fullpage>
            );
        }

        //자세히 보기 internal language 할당
        let lang = this.props.universal.language;

        //Map ExplainCards
        let ex = this.props.introductions.map((obj, idx) => {
            const blackIdx = [0,3,4,7];
            let rightIdx = [0,1,4,5];
            if(window.innerWidth < 770) rightIdx = [0,2,4,6];
            return (
                <ExplainCard
                    data={obj}
                    lang={lang}
                    index={idx}
                    // right={rightIdx.includes(idx) ? true : false}
                    // black={blackIdx.includes(idx) ? true : false}
                    right={rightIdx.indexOf(idx) !== -1 ? true : false}
                    black={blackIdx.indexOf(idx) !== -1 ? true : false}
                    key={idx}
                />
            )
        })

        //SideBar
        const sideBar = 
        <div className="Sidebar">
            <div className="Title"><h3>{Language.introduction.sidebar.title[lang]}</h3></div>
            <div className="Pointer">
                {Icons.rightPointer}
            </div>
            <div className="ContentWrapper">
                <div className="Content">
                    <p>{Language.introduction.sidebar.content[lang]}</p>
                    <Button 
                        language={this.props.universal.language} 
                        name={{"en": "Contact", "ko": "문의하기"}}
                        link={"community#Contact-01"}/>
                </div>
            </div>
        </div>

        return (
            <div className='Introduction'>
                {/* {sideBar} */}
                <div className="Explanation">{ex}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        introductions : state.home.introductions
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadIntroductions : () => {
            dispatch(homeActions.loadIntroductions());
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Introduction);


// WEBPACK FOOTER //
// ./src/pages/Home/Introduction/Introduction.js